import styled from "@emotion/styled";
import { useTheme } from "@mui/material";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

const StyledSection = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(4),
    maxWidth: "80%",
}));

const StyledRow = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(2),
    display: "flex",
    gap: theme.spacing(2),
}));

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
}));

export const ModuleDataSkeleton = () => {
    const theme = useTheme();

    return (
        <>
            <StyledSection>
                <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"20%"} />

                <StyledRow>
                    <StyledSkeleton variant="rectangular" height={theme.spacing(6)} width={"40%"} />
                    <StyledSkeleton variant="rectangular" height={theme.spacing(6)} width={"40%"} />
                </StyledRow>
            </StyledSection>

            <StyledSection>
                <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"20%"} />

                <StyledRow>
                    <Skeleton variant="circular" width={theme.spacing(5)} height={theme.spacing(5)} />
                    <StyledSkeleton variant="rectangular" height={theme.spacing(5)} width={"100%"} />
                </StyledRow>
            </StyledSection>
        </>
    );
};
